<template>
  <div>
    <div class="passes d-flex flex-column"
    :style="{
      '--color': item['package-text-color'],
      '--background': item['package-background'],
      '--button-background': item['package-button-background'],
      '--button-color': item['package-button-text-color'],
    }">
      <div class="pass_titles">
        <p class="m-0 d-flex flex-column" v-html="name"/>
      </div>
      <hr>
      <div class="passes_accesses px-3 d-flex flex-column gap-05 flex-grow-1 mb-5 mt-3">
        <template
          v-for="({callback, key, name, needStyle}) in rowsData"
        >
          <template v-for="({data, cellKey, styles}) of callback([item], {
            displayType: PASS_DISPLAY_TYPE.CARD
          })">
            <div
              v-if="data.displayForCard"
              :key="`${key}_${cellKey}`"
              :class="data.className"
              class="d-flex gap-1"
              :style="needStyle? styles: {}"
            >
              <component v-if="data.component" :is="data.component"/>
              <div v-if="data.html" v-html="data.html"/>
              <template v-if="data.text">{{ data.text }}</template>
              <span v-html="data.textForCard || name"/>
            </div>
          </template>
        </template>
        <div
          v-html="additionalInfo.logins.text"
          class="table_additional mt-2"
        />
      </div>
      <div
        class="passes_button d-flex justify-content-center flex-column
        gap-005 align-items-center p-1"
      >
        <slot name="button">
          <app-link
            v-for="btn in button"
            :key="btn.key"
            :to="btn.link"
            :disabled="btn.disabled"
            :title="btn.buttonText.title"
          >
            <p
              class="d-flex flex-column"
              v-html="btn.buttonText.html"
            />
          </app-link>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex';
import AppLink from '@/components/base-components/AppLink.vue';
import {ORDER_TYPE, PACKAGE_TYPES, PASS_DISPLAY_TYPE, SUBSCRIPTION_PERIODS} from '@/const';
import CheckIcon from '@/assets/img/CheckIcon.vue';
import {
  getPassButtons,
  tableRows,
  additionalInfo,
} from '@/components/base-components/Packages/passes';
import {parseStringBySeparatorToHtml} from '@/utils/helpers';
import Vue from 'vue';

export default {
  name: 'PassComponent',
  components: {
    CheckIcon,
    AppLink,
  },
  SUBSCRIPTION_PERIODS,
  PACKAGE_TYPES,
  PASS_TYPES: {
    PACKAGE: ORDER_TYPE.package,
    SUBSCRIPTION: ORDER_TYPE.subscription,
    EVENT: ORDER_TYPE.event,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    isRecommended: {
      default: true,
    },
    buttonText: {
      default: 'Get Access',
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    additionalInfo() {
      return additionalInfo;
    },
    PASS_DISPLAY_TYPE() {
      return PASS_DISPLAY_TYPE;
    },
    ...mapState({
      channelSettings: (state) => state.channel.settings,
      participants: (state) => state.participant.participantsList,
    }),
    ...mapGetters({
      isLogged: 'isLogged',
    }),
    rowsData() {
      return tableRows.slice(1);
    },
    name() {
      const langObj = Object.fromEntries(
          Object.entries(this.item.name_lang || {})
              .map(([key, value]) => [key.toLowerCase(), value]),
      );
      const name = langObj?.[Vue.i18n.locale().toLowerCase()] || this.item.name;
      return parseStringBySeparatorToHtml(name, '\\r\\n', 'span');
    },
    type() {
      return this.item.passType || ORDER_TYPE.package;
    },
    button() {
      return getPassButtons({
        item: this.item,
        isLogged: this.isLogged,
        currency: this.channelSettings.currency,
        route: this.$route,
      });
    },
  },
};
</script>

